import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "user-order-container" }
const _hoisted_4 = { class: "order-content" }
const _hoisted_5 = {
  key: 0,
  class: "table-outer"
}
const _hoisted_6 = {
  key: 0,
  class: "table-body"
}
const _hoisted_7 = { class: "body-head" }
const _hoisted_8 = { class: "head-item" }
const _hoisted_9 = { class: "head-item" }
const _hoisted_10 = { class: "head-item me-text-beyond" }
const _hoisted_11 = { class: "head-item" }
const _hoisted_12 = { class: "head-item" }
const _hoisted_13 = { class: "body-view" }
const _hoisted_14 = { class: "table-column mdxq-name" }
const _hoisted_15 = { class: "product-principal" }
const _hoisted_16 = { class: "table-column mdxq-address" }
const _hoisted_17 = { class: "product-principal" }
const _hoisted_18 = { class: "product-sku" }
const _hoisted_19 = { class: "table-column mdxq-column" }
const _hoisted_20 = { class: "table-column mdxq-column" }
const _hoisted_21 = {
  key: 1,
  class: "empty"
}
const _hoisted_22 = {
  key: 1,
  class: "table-outer"
}
const _hoisted_23 = {
  key: 0,
  class: "table-body"
}
const _hoisted_24 = { class: "body-head" }
const _hoisted_25 = { class: "head-item" }
const _hoisted_26 = { class: "head-item" }
const _hoisted_27 = { class: "head-item" }
const _hoisted_28 = { class: "head-item" }
const _hoisted_29 = { class: "head-item" }
const _hoisted_30 = { class: "head-item me-text-beyond" }
const _hoisted_31 = { class: "table-column commodity-column" }
const _hoisted_32 = { class: "product-principal" }
const _hoisted_33 = {
  key: 0,
  class: "product-sku"
}
const _hoisted_34 = { class: "table-column rests-column" }
const _hoisted_35 = { class: "table-column rests-column" }
const _hoisted_36 = { class: "table-column rests-column" }
const _hoisted_37 = { class: "product-principal" }
const _hoisted_38 = {
  key: 1,
  class: "empty"
}
const _hoisted_39 = {
  key: 0,
  class: "loading"
}
const _hoisted_40 = { class: "footer" }

import { computed, ref, watchEffect } from 'vue';
import { orderStatusFn, disposeServerDateFn, channelFn, mdxqOrderStatusFn } from '../../../utils/enum'
import { queryUserOrderApi, queryUserMdxqOrderApi } from '@/utils/user';
import pagination from './pagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'orderDetail',
  props: {
    userDetail: {}
  },
  setup(__props: any) {

const isShowPagination = ref(false)
const props = __props

// tab配置相关
const tabList: any = ref([
	{
		name: '近3个月订单',
		key: 'recent3MonthsOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '全部订单',
		key: 'allOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '蔓迪星球订单',
		key: 'mdxqOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	}
])

// 监听tab切换，获取当前tab对应的table的数据
const currentTableOptions:any = computed(() => {
	const result = tabList.value.find((item: any) => item.key === currentActive.value)
	isShowPagination.value = result.tableList && result.tableList.length && props.userDetail.syMemberId
	return result;
})

const loading = ref(false)
const currentActive = ref('recent3MonthsOrders');

// 获取订单列表
const getOrderList = async (key: string) => {
	try {
		loading.value = true;
		console.log(currentTableOptions, "currentTableOptions");
		
		const params: any = {
			"pageNum": currentTableOptions.value.currentPage,
			"pageSize": currentTableOptions.value.pageSize,
			"syMemberId": props.userDetail.syMemberId
		}
		let res: any = {}
		if (currentActive.value === 'mdxqOrders') {
			res = await queryUserMdxqOrderApi({
				...params,
				customerId: props.userDetail.id
			})
		} else {
			res = await queryUserOrderApi(currentActive.value === 'recent3MonthsOrders' ? { ...params, nearly: 1 } : params)
		}

		tabList.value.map((item: any) => {
			if (item.key === key) {
				item.tableList = res?.body?.list || []
				item.total = res?.body?.count || 0

				console.log('okkoo', tabList.value);

			}
		})
	} catch (err: any) {
		console.log(err);
	} finally {
		loading.value = false;
	}
}


const handleCurrentChange = (val: number) => {
	getOrderList(currentActive.value)
}

const handleSizeChange = (val: number) => {
	getOrderList(currentActive.value)
}


// tab切换
const tabChange = async (item: any) => {
	currentActive.value = item.key
	if (!item.isLoad && (props.userDetail.syMemberId || currentActive.value === 'mdxqOrders')) {
		item.isLoad = true
		await getOrderList(item.key)
	}
}


const isFirstLoad = ref(true)

// 监听，如果当前没有syMemberId，就不加载数据
watchEffect(() => {
	if (props.userDetail.syMemberId || currentActive.value === 'mdxqOrders') {
		if (isFirstLoad.value) {
			tabList.value.map((item: any) => {
				if (item.key === currentActive.value) {
					item.isLoad = true
				}
			})
			getOrderList(currentActive.value)
			isFirstLoad.value = false;
		}
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", [item.key === currentActive.value ? 'active' : '']]),
          key: item.key,
          onClick: ($event: any) => (tabChange(item))
        }, _toDisplayString(item.name), 11, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (currentActive.value === 'mdxqOrders')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"table-head\" data-v-2404a01a><div class=\"table-column mdxq-name\" data-v-2404a01a>礼品名称</div><div class=\"table-column mdxq-address\" data-v-2404a01a>收货人/收货地址</div><div class=\"table-column mdxq-column\" data-v-2404a01a>数量</div><div class=\"table-column mdxq-column\" data-v-2404a01a>消耗能量值</div></div>", 1)),
              (currentTableOptions.value.tableList.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTableOptions.value.tableList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "body-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[2] || (_cache[2] = _createTextVNode("订单号：", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.id), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[3] || (_cache[3] = _createTextVNode("下单时间：", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.order_time), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[4] || (_cache[4] = _createTextVNode(" 交易状态：", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(mdxqOrderStatusFn)(item.status)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[5] || (_cache[5] = _createTextVNode("发货快递：", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.express_company), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _cache[6] || (_cache[6] = _createTextVNode("发货单号：", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.express), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.recv_name) + "（" + _toDisplayString(item.recv_mobile) + "）", 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.num || 0), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.score || 0), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (currentTableOptions.value.tableList.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "暂无数据"))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"table-head\" data-v-2404a01a><div class=\"table-column commodity-column\" data-v-2404a01a>商品</div><div class=\"table-column rests-column\" data-v-2404a01a>商品标价</div><div class=\"table-column rests-column\" data-v-2404a01a>购买数量</div><div class=\"table-column rests-column\" data-v-2404a01a>商品实付价</div></div>", 1)),
              (props.userDetail.syMemberId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTableOptions.value.tableList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "body-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(channelFn)(item.platCode)) + "-" + _toDisplayString(_unref(channelFn)(item.platCode,
								'shopName')), 1),
                          _createElementVNode("div", _hoisted_26, [
                            _cache[8] || (_cache[8] = _createTextVNode("订单号：", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.orderSn), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _cache[9] || (_cache[9] = _createTextVNode("下单时间：", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.addTime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _cache[10] || (_cache[10] = _createTextVNode("付款时间：", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.payTime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _cache[11] || (_cache[11] = _createTextVNode("完成时间：", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(disposeServerDateFn)(item.endTime)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _cache[12] || (_cache[12] = _createTextVNode(" 交易状态：", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(orderStatusFn)(item.orderStatus)), 1)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.syOrderItemList, (orderItem, orderIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "body-view",
                            key: orderIndex
                          }, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(orderItem.productName), 1),
                              (orderItem.skuDetail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(orderItem.skuDetail), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_34, "￥" + _toDisplayString(orderItem.goodsPrice || 0), 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(orderItem.goodsNumber || 0), 1),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, "￥" + _toDisplayString(orderItem.payment || 0), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!props.userDetail.syMemberId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, "暂无数据"))
                : _createCommentVNode("", true)
            ]))
      ]),
      (props.userDetail.syMemberId && loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, "加载中..."))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_40, [
      (isShowPagination.value)
        ? (_openBlock(), _createBlock(pagination, {
            key: 0,
            "current-page": currentTableOptions.value.currentPage,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentTableOptions.value.currentPage) = $event)),
            "page-size": currentTableOptions.value.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((currentTableOptions.value.pageSize) = $event)),
            total: currentTableOptions.value.total,
            "page-sizes": [10, 20, 30, 40],
            layout: "total, sizes, prev, pager, next, jumper",
            background: true,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})